<template>
  <Popover ref="panelPopover" :showHeader="true" :headerTitle="headerTitle">
    <div class="production-preview-panel-popover" v-if="panel">
      <div class="row">
        <div class="col-12 panel-popover-display">
          <div class="font-weight-bold">Despatch Type</div>
          <div>{{order.despatchType | formatLookupName(DespatchTypeLookup)}}</div>
          <template v-if="panel.dateProductionCompleted">
            <div class="font-weight-bold">Completed Production</div>
            <div>{{panel.dateProductionCompleted | formatDateTime}}</div>
          </template>
          <div class="font-weight-bold">Despatch Due</div>
          <div>{{panel.dateDespatchDue | formatDateTime}}</div>
          <template v-if="panel.dateCompleted">
            <div class="font-weight-bold">Completed</div>
            <div>{{panel.dateCompleted | formatDateTime}}</div>
          </template>
          <FormHorizontalRule />
          <div class="font-weight-bold">Associated Despatch Tasks</div>
          <template v-if="linkedTaskInfoList.length > 0">
            <div v-for="task of linkedTaskInfoList" :key="task.id" class="row">
              <div class="col-3">
                <LinkTask :id="task.id" :name="task.sequenceNumber" />
              </div>
              <div class="col-3">
                <LabelBadge :labelClass="`label-task-status-${task.status}`">{{task.status | formatLookupName(TaskStatusTypeLookup)}}</LabelBadge>
              </div>
              <div class="col-6">
                <template v-if="task.status == TaskStatusTypes.ready || task.status == TaskStatusTypes.loading">
                  {{task.startedDate | formatDateTime}}
                </template>
                <template v-if="task.status == TaskStatusTypes.completed">
                  {{task.completedDate | formatDateTime}}
                </template>
                <template v-if="task.status == TaskStatusTypes.cancelled">
                  {{task.cancelledDate | formatDateTime}}
                </template>
              </div>
            </div>
          </template>
          <div v-if="linkedTaskInfoList.length == 0">None</div>
        </div>
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.production-preview-panel-popover {
  padding: 10px;
  font-size: 0.8rem;
  line-height: 1.1rem;
  min-width: 400px;
}
.panel-popover-display > div {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

import { DespatchTypeLookup, TaskStatusTypes, TaskStatusTypeLookup } from '@/store/types'

export default {
  name: 'OrderProductionPanelDespatchPopover',
  components: {
    Popover
  },
  computed: {
    barcode() {
      if(this.panel)
        return this.panel.barcode
      return ''
    },
    headerTitle() {
      return `Panel ${this.barcode} - Despatch`
    }
  },
  data() {
    return {      
      order: null,
      panel: null,
      taskList: [],
      linkedTaskInfoList: []
    }
  },
  created() {
    this.DespatchTypeLookup = DespatchTypeLookup
    this.TaskStatusTypes = TaskStatusTypes
    this.TaskStatusTypeLookup = TaskStatusTypeLookup
  },
  methods: {
    displayFromElement(element, panel, order, taskList) {
      this.panel = panel
      this.order = order
      this.taskList = taskList

      this.calculateLinkedTaskList()

      this.$refs.panelPopover.displayFromElement(element)
    },
    calculateLinkedTaskList() {
      this.linkedTaskInfoList = []

      this.taskList.forEach(task => {
        if(task.taskItems) {
          let linkedTaskItems = task.taskItems.filter(taskItem => {
            if(taskItem.orderItems)
              return taskItem.orderItems.find(listOrderItem => listOrderItem.id == this.panel.orderItemId) != null
            return false
          })

          if(linkedTaskItems.length > 0) {
            this.linkedTaskInfoList.push(_.merge(task, {
              linkedTaskItems: linkedTaskItems
            }))
          }
        }
      })
    }
  }
}
</script>